import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Table from "../../../_common/Table";
import EditProjContractorsModal from "./EditProjContractorsModal";
import ProjAdminProjContractorDetails from "./ProjContractorDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import contractorActions from "../../../../_actions/contractorActions";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import EditProjContractorModal from "./EditProjContractorModal";
import projActions from "../../../../_actions/projActions";
import EditProjContractorsModalV2 from "./EditProjContractorsModalV2";

class ProjAdminContractors extends Component {
  state = {
    sortColumn: { path: "name", order: "asc" },
    nameFilter: "",
    selectedContractorId: null,
    showEditPcModal: false,
    showEditPcDetailsModal: false,
  };

  columns = [
    { path: "name", label: "Name" },
    { path: "abbreviation", label: "Abbrev." },
    {
      path: "isPrime",
      label: "Prime/Sub",
      content: (c) =>
        c.isPrime ? (
          <span className="span-bubble bg-success p-1">Prime</span>
        ) : c.isSupplier ? (
          <span className="span-bubble bg-dark p-1">Supplier</span>
        ) : (
          <span className="span-bubble bg-secondary p-1">Sub</span>
        ),
    },
  ];

  componentDidMount() {
    const { dispatch, projectId } = this.props;
    dispatch(contractorActions.getAllForProject(projectId));
  }

  handleChange_nameFilter = (e) => this.setState({ nameFilter: e.target.value });

  handleSort = (sortColumn) => this.setState({ sortColumn });

  handleClick_contractorTr = (selectedContractor) => {
    const { dispatch, projectId } = this.props;
    dispatch(
      projActions.getContractorDetails(projectId, selectedContractor.contractorId)
    );
    this.setState({ selectedContractorId: selectedContractor.contractorId });
  };

  handleClick_editPcDetails = () => this.toggleEditPcDetailsModal();

  getData = () => {
    const { projContractorList } = this.props;
    const { nameFilter, sortColumn } = this.state;

    const filteredByName =
      nameFilter !== null
        ? (projContractorList || []).filter((c) =>
            c.name.toLowerCase().includes(nameFilter.trim().toLowerCase())
          )
        : projContractorList || [];
    return _.orderBy(filteredByName, [sortColumn.path], [sortColumn.order]);
  };

  handleClick_editPc = (e) => {
    e.preventDefault();
    this.toggleEditPcModal();
  };

  toggleEditPcModal = () =>
    this.setState({
      showEditPcModal: !this.state.showEditPcModal,
    });

  toggleEditPcDetailsModal = () =>
    this.setState({ showEditPcDetailsModal: !this.state.showEditPcDetailsModal });

  renderFilters = () => {
    const { nameFilter } = this.state;
    const { permissions } = this.props;
    return (
      <div className="d-flex flex-row flex-wrap w-100 pa-filter-group mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1 mr-2">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="nameFilter"
              id="nameFilter"
              className="form-control col-12"
              value={nameFilter}
              onChange={this.handleChange_nameFilter}
              placeholder="Contractor Name"
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="editProjContractor"
            id="editProjContractor"
            className="btn btn-info px-2"
            onClick={this.handleClick_editPc}
            disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
          >
            <FontAwesomeIcon icon="tasks" className="fa-fw mr-1" />
            Select/Add...
          </button>
        </div>
      </div>
    );
  };

  renderTable = () => {
    const { sortColumn, selectedContractorId } = this.state;
    const data = this.getData();
    return (
      <div className="pa-list__table--wrapper border">
        <Table
          className="table table-sm table-hover pa-list__table"
          data={data}
          columns={this.columns}
          idPropName="contractorId"
          selectedItemId={selectedContractorId && selectedContractorId}
          sortColumn={sortColumn}
          onSort={this.handleSort}
          handleClick_tr={this.handleClick_contractorTr}
        />
      </div>
    );
  };

  render() {
    const { projectId, tabId, projContractorList, permissions } = this.props;
    const { selectedContractorId, showEditPcModal, showEditPcDetailsModal } = this.state;
    return (
      <React.Fragment>
        <div className="d-flex flex-row w-100 p-2">
          <div className="pa-list">
            {this.renderFilters()}
            {this.renderTable()}
          </div>
          <div className="pa-details">
            <ProjAdminProjContractorDetails
              projectId={projectId}
              contractorId={selectedContractorId}
              toggleEditPcDetailsModal={this.toggleEditPcDetailsModal}
              permissions={permissions}
            />
          </div>
        </div>
        {showEditPcModal && (
          <EditProjContractorsModalV2
            tabId={tabId}
            projectId={projectId}
            showEditPcModal={showEditPcModal}
            toggleEditPcModal={this.toggleEditPcModal}
          />
        )}
        {showEditPcDetailsModal && (
          <EditProjContractorModal
            projectId={projectId}
            contractorId={selectedContractorId}
            toggleEditPcDetailsModal={this.toggleEditPcDetailsModal}
            showEditPcDetailsModal={showEditPcDetailsModal}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(ProjAdminContractors);
